//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "FlowResult",
	props: {
		result: Object,
		openInNewWindow: Boolean,
		formatDate: Function,
	},
	computed: {},
	methods: {}
};
